<template>
    <div class="relative mx-auto shadow-md rounded-md" style="min-width:400px; max-width: 400px;"
    >
        <canvas
            :id="$props.id ? $props.id : 'canvas'"
            class="relative"
            style="z-index: 1"
        ></canvas>

        <div  v-if="spinner" style="z-index: 2" class="bg-spinner bg-white  bg-opacity-50 absolute inset-0 flex items-center justify-center">
            <svg class="animate-spin h-8 w-8 text-gray-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </div>
    </div>
</template>

<script>
import { onMounted, ref, watch } from '@vue/runtime-core';
import { unserialize } from 'php-serialize';

const size = {
    width: 400,
    height: 400,
}

export default {
    props: ['item', 'type', 'id'],
    emits: ['copy'],
    setup(props, { emit }) {

        // Variables

        const
            ctx = ref(null),
            canvas = ref(null),
            refresh = ref(true),
            ready = ref(false),
            spinner = ref(true),
            lines = ref([]);

        onMounted(() => {
            canvas.value = document.getElementById(props.id ? props.id : 'canvas');
            ctx.value = canvas.value.getContext('2d');

            ctx.value.canvas.width = size.width;
            ctx.value.canvas.height = size.height;

            arrText(props.item.content);
            loadImage(props.item.product_details.product_variation.engrave.image.url);
        });

        function loadImage(url) {
            spinner.value = true;
            const image = new Image();
            image.src = url;

            image.onload = () => {
                refresh.value = true;
                ctx.value.drawImage(image, 0, 0, ctx.value.canvas.width, ctx.value.canvas.width);

                if(props.item.product_details.pictogram && props.item.pictogram_id) loadPictogram(props.item.product_details.pictogram);
                else {
                    ready.value = true;
                    draw();

                    setTimeout(() => {
                        spinner.value = false;
                        copy();
                    }, 500)
                }
            }
        };

        function loadPictogram(val) {
            var icon = new Image;
            icon.src = val.url;
            icon.onload = (ev) => {
                let path = ev.path || (ev.composedPath && ev.composedPath());
                let bottomH = size.height - path[0].height;

                ctx.value.drawImage(icon, 20, bottomH - 20, path[0].width, path[0].height);

                ready.value = true;
                draw();
                setTimeout(() => {
                    spinner.value = false;
                    copy();
                }, 500)
            }

        };
        function copy() {
            if(props.type && props.type == 'copy') {
                navigator.permissions.query({name: "clipboard-write"}).then(result => {
                    if (result.state == "granted" || result.state == "prompt") {
                        canvas.value.toBlob(blob => navigator.clipboard.write([new ClipboardItem({'image/png': blob})]))
                    }
                });

                emit('copy', true);
            }
        }
        function draw() {
            let area = unserialize(props.item.product_details.product_variation.engrave.option.area);

            ctx.value.fillStyle = props.item.details.color;
            ctx.value.textAlign = 'left';

            if(lines.value.length > 1) ctx.value.textBaseline = 'top';
            else ctx.value.textBaseline = 'middle';

            lines.value.forEach((el, key) => {
                ctx.value.font = el.fontSize + 'px ' + props.item.product_details.font.family;

                if(lines.value.length > 1) el.y = area.y + (key == 0 ? 0 : lines.value[key - 1].fontSize);
                else el.y = area.y + (area.h / 2);

                ctx.value.fillText( el.text, el.position, el.y, area.w );
            });
        };

        function arrText(text, refresh = false) {
            let arr = text.split('\n');
            let details = props.item.details;
            lines.value = [];

            arr.forEach((el, key) => {
                lines.value[key] = {
                    id: key + 1,
                    text: el,
                    y: null,
                    position: details.position[key],
                    fontSize: details.fontSize[key],
                }
            });
        }

        return {
            size,
            spinner,
            lines,
        }
    },
}
</script>
